import { gql } from '@apollo/client';

export interface ILibraryOfferType {
  id: string;
  name: string;
  internalName: string;
}

export const LibraryOfferTypeFragment = gql`
  fragment LibraryOfferType on LibraryOfferType {
    sys {
      id
    }
    name
    internalName
  }
`;
